export const ownerscabinImageOptions = {
  angle: 'ownerscabin',
  staticOptions: {
    Veneer: 1,
    Floorboard: 1,
    Handrail: 1,
    Fabric: 1,
    GalleyLayout: 1,
    Worktop: 1,
    SaloonTableBox: 1,
    SaloonPouffe: 1,
    SaloonBackRest: 1,
    CupboardsSaloon: 1,
    FabricOwnersCabin: 1,
    CupboardsOwnersCabin: 1,
    beautytable: 1,
    LargeWardrobe: 1,
    FabricAftCabin: 1,
    AftCabinLayout: 1,
    Mast: 1,
    LeatherHandles: 1
  },
  mattes: [
    {
      option: 'Veneer',
      dependency: 'AftCabinLayout'
    },
    {
      option: 'Floorboard',
      dependency: 'GalleyLayout'
    },
    {
      option: 'FabricOwnersCabin',
      dependency: null
    },
    {
      option: 'CupboardsOwnersCabin',
      dependency: 'Veneer'
    },
    {
      option: 'beautytable',
      dependency: 'Veneer'
    },
    {
      option: 'LargeWardrobe',
      dependency: 'Veneer'
    },
    {
      option: 'LeatherHandles',
      dependency: 'Veneer'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/X56/views/ownerscabin.js